import script from "./spinner-climbing.vue?vue&type=script&setup=true&lang=js"
export * from "./spinner-climbing.vue?vue&type=script&setup=true&lang=js"

import "./spinner-climbing.vue?vue&type=style&index=0&id=76c3424a&lang=scss"

const __exports__ = script;

export default __exports__